var styles = {"box":"CategoryTitle_box_1t1ju_1","icon-wrapper":"CategoryTitle_icon-wrapper_1t1ju_7","title":"CategoryTitle_title_1t1ju_16","filter":"CategoryTitle_filter_1t1ju_24"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
